const TOKEN_KEY = 'token';
const USER_KEY = 'user';

const REMEMBER_KEY = {
  buyer: 'buyer_remember_me',
  seller: 'seller_remember_me',
};

const EMAIL_KEY = {
  buyer: 'buyer_login_email',
  seller: 'seller_login_email',
};

export function getAuthToken() {
  return sessionStorage.getItem(TOKEN_KEY) || localStorage.getItem(TOKEN_KEY);
}

export function persistAuthSession(user, token, rememberMe = true) {
  const primary = rememberMe ? localStorage : sessionStorage;
  const secondary = rememberMe ? sessionStorage : localStorage;

  primary.setItem(TOKEN_KEY, token);
  primary.setItem(USER_KEY, JSON.stringify(user));
  secondary.removeItem(TOKEN_KEY);
  secondary.removeItem(USER_KEY);
}

export function clearAuthSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
  sessionStorage.removeItem(TOKEN_KEY);
  sessionStorage.removeItem(USER_KEY);
}

export function getStoredUserJson() {
  return localStorage.getItem(USER_KEY) || sessionStorage.getItem(USER_KEY);
}

export function loadLoginPrefs(role) {
  const r = role === 'seller' ? 'seller' : 'buyer';
  const rememberMe = localStorage.getItem(REMEMBER_KEY[r]) !== 'false';
  const email = localStorage.getItem(EMAIL_KEY[r]) || '';
  return { rememberMe, email };
}

export function saveLoginPrefs(role, email, rememberMe) {
  const r = role === 'seller' ? 'seller' : 'buyer';
  if (rememberMe) {
    localStorage.setItem(REMEMBER_KEY[r], 'true');
    if (email) localStorage.setItem(EMAIL_KEY[r], email);
  } else {
    localStorage.setItem(REMEMBER_KEY[r], 'false');
    localStorage.removeItem(EMAIL_KEY[r]);
  }
}

/** @deprecated use loadLoginPrefs('seller') */
export function loadSellerLoginPrefs() {
  return loadLoginPrefs('seller');
}

/** @deprecated use saveLoginPrefs('seller', ...) */
export function saveSellerLoginPrefs(email, rememberMe) {
  saveLoginPrefs('seller', email, rememberMe);
}
